import { isNotDefined } from '@sgme/fp';
import { HStack } from '@sgme/ui';
import type { CustomCellRendererProps } from 'ag-grid-react';
import { FormattedMessage, FormattedNumber } from 'react-intl';

import { blotterOrderStatusIsFinal } from '@/store/blotter/api/types/BlotterOrderEntryFromBackend.ts';
import type { BlotterOrderEntry } from '@/store/blotter/types/BlotterOrderEntry.ts';

export const AmountDoneCellRenderer = ({ data: orderEntry }: CustomCellRendererProps<BlotterOrderEntry, string>) => {
  if (isNotDefined(orderEntry) || isNotDefined(orderEntry.notional) || orderEntry.notional <= 0) {
    return null;
  }
  const { executedAmount, notional, status } = orderEntry;
  const progressPercentage = Math.floor((100 * (executedAmount ?? 0)) / notional);

  const isFinal = blotterOrderStatusIsFinal(status);

  return (
    <HStack className={isFinal ? '' : 'text-info'}>
      <div>
        {`${progressPercentage}%`}{' '}
        <FormattedMessage id={`blotter.tab.Order.column.amountDone.${isFinal ? 'filled' : 'beingFilled'}`} />
      </div>
      <div className="ms-1 text-secondary">
        {executedAmount === null ? null : <FormattedNumber value={executedAmount} />}
      </div>
    </HStack>
  );
};
